import { render } from "./PhotographerVTwo_Sange.vue?vue&type=template&id=48a62320&scoped=true"
import script from "./PhotographerVTwo_Sange.vue?vue&type=script&lang=js"
export * from "./PhotographerVTwo_Sange.vue?vue&type=script&lang=js"

import "./PhotographerVTwo_Sange.vue?vue&type=style&index=0&id=48a62320&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a62320"]])

export default __exports__